import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './CountIndicator.scss';

const CountIndicator = ({ count, hide, badge }) => {
    if (hide || !count) return null;

    return <div className={classNames('CountIndicator', { badge })}>{count}</div>;
};

CountIndicator.propTypes = {
    count: PropTypes.number,
    hide: PropTypes.bool,
    badge: PropTypes.bool,
};

export default CountIndicator;
